const Spinner = () => {
  return <div>Lade ...</div>
}

export default Spinner